import * as React from 'react';
import { Download } from 'lucide-react';
import { Button } from './Button';
import { EmptyState } from './EmptyState';
import { Center } from './Layout';

export interface UpdateRequiredProps {
  /** The store's name, for the button: "the App Store", "Google Play". */
  store: string;
  /** Open the store page. The app asks the native bridge. */
  onUpdate: () => void;
  title?: React.ReactNode;
  message?: React.ReactNode;
}

/**
 * The whole screen, when the app on the phone is too old for the server:
 * what has happened, and the button to the store.
 *
 *   <UpdateRequired store="the App Store" onUpdate={bridge.openStore} />
 *
 * Nothing else on the screen, and no way past it. An older build talks to
 * the server in a way the server has stopped answering, so anything it
 * showed would fail.
 */
export function UpdateRequired({
  store,
  onUpdate,
  title = 'Update Relay',
  message = 'This version of Relay is no longer supported. Update to keep taking calls.',
}: UpdateRequiredProps) {
  return (
    <Center fill="screen" className="px-6">
      <EmptyState
        icon={Download}
        title={title}
        description={message}
        action={<Button onClick={onUpdate}>Open {store}</Button>}
      />
    </Center>
  );
}
